import { COLORS } from "../../theme/colors";

export const POWER_ASSETS_LEGENDS = {
  SOLAR: "solar",
  BATTERY: "battery",
  EV: "ev",
};

export const POWER_ASSETS_COLORS = {
  [POWER_ASSETS_LEGENDS.SOLAR]: COLORS.lightYellow,
  [POWER_ASSETS_LEGENDS.BATTERY]: COLORS.majorelleBlue,
  [POWER_ASSETS_LEGENDS.EV]: COLORS.cian,
};
